import React, { useCallback } from 'react';
import { memo } from 'react';

import {
  Text,
  Image,
  useBreakpoint,
  Breakpoint,
  Box,
  Swiper,
} from '@betty/moonlight';

import { LandingCarouselProps } from './LandingCarouselProps.types';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { Pressable } from 'react-native';

function LandingCarousel({ items, category }: LandingCarouselProps) {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === Breakpoint.MOBILE;

  const handlePress = useCallback(
    (name: string) => {
      navigation.navigate('GameInfoScreen', { name });
    },
    [navigation]
  );

  const swiperItems = items.map((provider) => ({
    image: '',
    img: provider.imgSrc,
    name: provider.name,
  }));

  return (
    <Box gap="space-400">
      {category && (
        <Text variant="h5" color="darkSurfacePrimary">
          {category}
        </Text>
      )}

      <Box
        width="100%"
        flexDirection="column"
        alignItems="center"
        height={{
          desktop: 150,
          tablet: 150,
          mobile: 92,
        }}
      >
        <Swiper
          items={swiperItems}
          renderOverlayItem={(item) => (
            <div style={{ position: 'relative' }}>
              <Pressable onPress={() => handlePress(item.name)}>
                <Image
                  width={{
                    desktop: 150,
                    tablet: 150,
                    mobile: 92,
                  }}
                  height={{
                    desktop: 150,
                    tablet: 150,
                    mobile: 92,
                  }}
                  name={item.img}
                />
              </Pressable>
            </div>
          )}
          itemRadius="radius-400"
          maxHeight="100%"
          loop={false}
          imageContentFit="contain"
          dragFree={true}
          slidesToScroll={2}
          itemsGap="space-400"
          arrows={isMobile ? false : true}
        />
      </Box>
    </Box>
  );
}

export default memo(LandingCarousel);
